import axios from 'axios'
import errorParser from '@/utils/error-parser'

// Emission coverage: facilities/media whose daily totals carry no emission
// (CO2e and cost silently 0). See documentation/features/facility-emissions.md.
export default {
  // admin: all gaps across organizations
  listGaps () {
    return new Promise((resolve, reject) => {
      axios.get('/emissioncoverage').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  // caretaker/admin: every medium with sensors of one facility
  facilityCoverage (facilityId) {
    return new Promise((resolve, reject) => {
      axios.get('/facilities/' + facilityId + '/emissioncoverage').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  // admin: repair one facility/medium; supplyContractId null = unique standard template
  fix (facilityId, type, supplyContractId) {
    return new Promise((resolve, reject) => {
      axios.post('/facilities/' + facilityId + '/emissioncoverage/fix', { type, supplyContractId: supplyContractId || null }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
